import React, { useContext, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderInner from "../Components/HeaderInner";
import { ThemeContext } from "../context/ThemeContext";
import Title from "../new-components/title/Title";
import NewFooter from "../NewFooter";
import Footer from "../Components/Footer";
import { Button } from "react-bootstrap";
import { FaHome } from "react-icons/fa"; // 👈 Home icon

const WashmenFrame = () => {
  const loaderRef = useRef();
  const navigate = useNavigate();
  const params = useParams();
  const handleLoad = () => {
    if (loaderRef.current) {
      loaderRef.current.style.display = "none";
      loaderRef.current.style.visibility = "hidden";
      loaderRef.current.remove();
    }
  };

  const { theme } = useContext(ThemeContext);
  const location = useLocation();
  const { washmenUrl } = location.state?.metadata;

  return (
    <div>
      <div
        className="full-div padd-div text-start"
        style={{ marginTop: "15px", marginLeft: "5px", marginBottom: "15px" }}
      >
        <Button
          onClick={() => {
            navigate(`/${params.room_uuid}/qr-code`);
          }}
          disabled={false}
          style={{
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: theme ? "white" : "var(--color)",
            border: "none",
          }}
        >
          <FaHome size={15} />
        </Button>
      </div>

      <div
        className="payment-iframe"
        style={{ marginTop: "0vh", minHeight: "86vh" }}
      >
        <div className="d-flex justify-content-center m-5" ref={loaderRef}>
          <div
            className="loader"
            style={{
              borderColor: "lightgray",
              borderRightColor: "#000000",
            }}
          ></div>
        </div>

        <iframe
          loading="lazy"
          src={washmenUrl}
          width="100%"
          height="100%"
          title="Payment Preview"
          scrolling="no"
          onLoad={handleLoad}
          allow="payment"
        ></iframe>
      </div>
    </div>
  );
};

export default WashmenFrame;
